export const CHANGE_USER_PHOTO = 'user:CHANGE_USER_PHOTO'
export const CHANGE_USER_PHOTO_SUCCESSFUL = 'user:CHANGE_USER_PHOTO_SUCCESSFUL'
export const CHANGE_USER_PHOTO_FAILURE = 'user:CHANGE_USER_PHOTO_FAILURE'

export const CHANGE_USER_EMAIL = 'user:CHANGE_USER_EMAIL'
export const CHANGE_USER_EMAIL_SUCCESSFUL = 'user:CHANGE_USER_EMAIL_SUCCESSFUL'
export const CHANGE_USER_EMAIL_FAILURE = 'user:CHANGE_USER_EMAIL_FAILURE'

export const CHANGE_USER_PASSWORD = 'user:CHANGE_USER_PASSWORD'
export const CHANGE_USER_PASSWORD_SUCCESSFUL = 'user:CHANGE_USER_PASSWORD_SUCCESSFUL'
export const CHANGE_USER_PASSWORD_FAILURE = 'user:CHANGE_USER_PASSWORD_FAILURE'

export const UPDATE_USER_DATA = 'user:UPDATE_USER_DATA'
export const UPDATE_USER_DATA_SUCCESSFUL = 'user:UPDATE_USER_DATA_SUCCESSFUL'
export const UPDATE_USER_DATA_FAILURE = 'user:UPDATE_USER_DATA_FAILURE'
